import { getMasterAdminOrganizationUserDetailsPath } from '@/bundle/_MasterAdmin/_OrganizationUserDetailsPage/path/path';
import { getOpcoUserDetailsPath } from '@/bundle/_Opco/_OpcoUsersPage/OpcoUserDetailsPage/path/path';
import { getProfilePath } from '@/bundle/pages/ProfilePage/path/path';
import { useLogout } from '@/bundle/shared/hooks/useLogout';
import { PopoverMenu } from '@/components/PopoverMenu/PopoverMenu';
import { useUser } from '@/context/userContext';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import { getFullName, getInitials } from './helpers';
import { getUserRoleLabel } from '@/helpers/userHelpers';
import { Avatar, UserType } from './styles';
import { Typography } from '@/components/Typography/Typography';
import { PopoverMenuItem } from '@/components/PopoverMenu/PopoverMenuItem';
import { IoLogOutOutline } from 'react-icons/io5';
import { LuUser } from 'react-icons/lu';
import { COLORS } from '@/styles/colors';
import { Box } from '@/components/Box/Box';
import UserIcon from '@/bundle/_Opco/_OpcoUsersPage/OpcoUserDetailsPage/images/UserIcon.svg?react';
import { UserDetailsIcon } from '@/bundle/_Opco/shared/styles';

export const UserPopoverMenu = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const { user, isOpcoRole, isMasterAdminRole, currentRole } = useUser();

  const { mutate: logoutMutate } = useLogout();

  const getCurrentUrl = () => {
    if (isOpcoRole) return getOpcoUserDetailsPath(user?.id);

    if (isMasterAdminRole) return getMasterAdminOrganizationUserDetailsPath(user?.id);

    return getProfilePath();
  };

  const navigateToProfile = () => {
    const currentUrl = getCurrentUrl();

    navigate(currentUrl);
  };

  const initials = getInitials(user);
  const fullName = getFullName(user);
  const email = user?.email;
  const userRole = getUserRoleLabel(currentRole);

  return (
    <PopoverMenu
      isOpen={isOpen}
      onToggleOpen={setIsOpen}
      placement='bottom-end'
      anchorSlot={<Avatar>{initials}</Avatar>}
      minWidth='280px'
    >
      <Box
        display='flex'
        padding='14px 16px'
        gap='16px'
        alignItems='center'
        borderBottom={`1px solid ${COLORS.grey[400]}`}
      >
        <UserDetailsIcon>
          <UserIcon />
        </UserDetailsIcon>

        <Box display='flex' gap='4px' flexDirection='column' minWidth={0}>
          <Typography variant='bodySmall' fontWeight='semibold'>
            {fullName}
          </Typography>
          <Typography variant='bodySmall2' fontWeight='medium' title={email}>
            {email}
          </Typography>
          <Typography>
            <UserType>{userRole}</UserType>
          </Typography>
        </Box>
      </Box>

      <PopoverMenuItem icon={<LuUser size={22} />} onClick={navigateToProfile}>
        Profile
      </PopoverMenuItem>
      <PopoverMenuItem icon={<IoLogOutOutline size={22} />} onClick={() => logoutMutate()}>
        Log out
      </PopoverMenuItem>
    </PopoverMenu>
  );
};
